export default [
  {
    name: 'Payroll List',
    desc: 'Manage all customers from different channels',
    icon: 'team',
    link: '/payrolls',
    enable: true,
    permission: 'listPayrolls'
  }
]
